<div class="container-fluid">
  <div class="button-navigation flex flex-row space-between items-center mt-5">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary tall" type="button"
      [routerLink]="['/profile', profileId]">
      <i class="pi pi-angle-left"></i>
      {{ 'profiles.back-to-profile' | translate | uppercase }}
    </button>
  </div>
  <h3 *ngIf="!windowed">{{ 'benefits.profile-benefit-mgt.title' | translate | titlecase }}</h3>
  <div [hidden]="!hasEventBenefits">
    <p [hidden]="!showBenefitHelp" class="text-danger">
      {{ 'benefits.messages.no-benefit-codes-1' | translate }}
      <a href="https://support.weblinkinternational.com/hc/en-us/articles/115006207288" target="_blank">{{
        'benefits.messages.no-benefit-codes-2' | translate
        }}</a>
      {{ 'benefits.messages.no-benefit-codes-3' | translate }}
    </p>
    <div [hidden]="!profile || profile.ProfileId <= 0" *ngIf="profile?.ProfileId > 0">
      <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd" [profileId]="profile.ProfileId"
        [memberTypeIconColor]="profile.MemberTypeIconColor"></wl-profile-type-icon><strong>{{ profile.ReportName }} ({{
        profile.ProfileId }})</strong>
      <button pButton type="button" class="atlas-btn atlas-btn-secondary ml-5" (click)="loadData()"
        icon="pi pi-refresh"></button>
    </div>
    <hr />

    <h4>{{ 'benefits.profile-benefit-mgt.active-benefits-label' | translate | titlecase }}</h4>

    <div class="form-row mct-flex mct-row mct-justify-between mct-items-stretch mb-5">
      <div class="mct-flex mct-justify-start mct-items-stretch">
        <button pButton class="atlas-btn atlas-btn-primary tall"
          [label]="'benefits.profile-benefit-mgt.add-benefit-label' | translate | titlecase" [icon]="'pi pi-plus'"
          (click)="addBenefit()">
        </button>
      </div>
      <div class="mct-flex mct-justify-end mct-items-stretch">
        <wl-busy [show]="isRenewing"></wl-busy>
        <button pButton class="atlas-btn atlas-btn-primary tall"
          [label]="'benefits.profile-benefit-mgt.renew-all-benefits-label' | translate | titlecase"
          [icon]="'pi pi-plus'" (click)="handleRenewProfileBenefitsClick()">
        </button>
      </div>
    </div>

    <p-table [showGridlines]="true" #benefitsDataGridActive [rows]="20" [value]="benefitsActive" [paginator]="true">
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th [pSortableColumn]="'BenefitType'">
            {{ 'benefits.profile-benefit-mgt.benefit-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'Quantity'" style="width: 80px">
            {{ 'benefits.profile-benefit-mgt.quantity-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'Quantity * Value'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.total-value-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'QuantityUsed'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.quantity-used-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'ValueUsed'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.amount-used-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'Quantity - QuantityUsed'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.quantity-remaining-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'ValueRemaining'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.amount-remaining-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'ExpirationDate'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.expiration-date-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template let-item pTemplate="body">
        <tr>
          <td>{{ item.BenefitType }}</td>
          <td>{{ item.Quantity }}</td>
          <td style="text-align: center !important">{{ item.Quantity * item.Value | currency }}</td>
          <td style="text-align: center !important">{{ item.QuantityUsed }}</td>
          <td style="text-align: center !important">{{ item.ValueUsed | currency }}</td>
          <td style="text-align: center !important">{{ item.Quantity - item.QuantityUsed }}</td>
          <td style="text-align: center !important">{{ item.ValueRemaining | currency }}</td>
          <td style="text-align: center !important">{{ item.ExpirationDate | date: 'shortDate' }}</td>
          <td>
            <div class="flex flex-row space-between w-100">
              <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="openFlagBenefit(item)"
                title="{{ 'benefits.profile-benefit-mgt.flag-benefit-title' | translate }}" icon="pi pi-flag"></button>
              <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="editBenefit(item)"
                title="{{ 'common.edit' | translate | titlecase }}" icon="pi pi-pencil"></button>
              <button pButton type="button" class="atlas-btn atlas-btn-danger tall" (click)="deleteBenefit(item)"
                title="{{ 'common.delete' | translate | titlecase }}" icon="pi pi-trash"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9" class="text-center">
            {{ 'benefits.no-benefits' | translate | titlecase }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>

    <div class="mt-27 mb-10">
      <h4>{{ 'benefits.profile-benefit-mgt.inactive-benefits-label' | translate | titlecase }}</h4>
    </div>

    <p-table [showGridlines]="true" #benefitsDataGridActive [rows]="20" [value]="benefitsExpired" [paginator]="true">
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th [pSortableColumn]="'BenefitType'">
            {{ 'benefits.profile-benefit-mgt.benefit-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'Quantity'" style="width: 80px">
            {{ 'benefits.profile-benefit-mgt.quantity-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'Quantity * Value'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.total-value-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'QuantityUsed'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.quantity-used-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'ValueUsed'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.amount-used-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'Quantity - QuantityUsed'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.quantity-remaining-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'ValueRemaining'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.amount-remaining-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'ExpirationDate'" style="text-align: center !important">
            {{ 'benefits.profile-benefit-mgt.expiration-date-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template let-item pTemplate="body">
        <tr>
          <td>{{ item.BenefitType }}</td>
          <td>{{ item.Quantity }}</td>
          <td style="text-align: center !important">{{ item.Quantity * item.Value | currency }}</td>
          <td style="text-align: center !important">{{ item.QuantityUsed }}</td>
          <td style="text-align: center !important">{{ item.ValueUsed | currency }}</td>
          <td style="text-align: center !important">{{ item.Quantity - item.QuantityUsed }}</td>
          <td style="text-align: center !important">{{ item.ValueRemaining | currency }}</td>
          <td style="text-align: center !important">{{ item.ExpirationDate | date: 'shortDate' }}</td>
          <td>
            <div class="flex row-collapse space-between">
              <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="openFlagBenefit(item)"
                title="{{ 'benefits.profile-benefit-mgt.flag-benefit-title' | translate }}" icon="pi pi-flag"></button>
              <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="editBenefit(item)"
                title="{{ 'common.edit' | translate | titlecase }}" icon="pi pi-pencil"></button>
              <button pButton type="button" class="atlas-btn atlas-btn-danger tall" (click)="deleteBenefit(item)"
                title="{{ 'common.delete' | translate | titlecase }}" icon="pi pi-trash"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9" class="text-center">
            {{ 'benefits.no-benefits' | translate | titlecase }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>

    <p-dialog #editBenefitModal [(visible)]="showEditBenefitModal" modal="true" [closable]="false"
      styleClass="atlas-dialog-xl" [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
      <ng-template pTemplate="header">
        <b *ngIf="selectedBenefit.Id == 0">{{ 'benefits.profile-benefit-mgt.add-benefit-title' | translate | titlecase
          }}</b>
        <b *ngIf="selectedBenefit.Id > 0">{{ 'benefits.profile-benefit-mgt.edit-benefit-title' | translate | titlecase
          }}</b>
      </ng-template>
      <wl-benefit-add #addBenefitComponent [(benefit)]="selectedBenefit"></wl-benefit-add>
      <ng-template pTemplate="footer">
        <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
        <button pButton type="button" class="atlas-btn atlas-btn-primary tall" [disabled]="isSaving"
          (click)="saveBenefit()" icon="pi pi-save">
          <span [hidden]="isSaving">{{ 'common.save' | translate | titlecase }}</span>
          <span [hidden]="!isSaving">{{ 'common.saving' | translate | titlecase }}</span>
        </button>
        <button pButton type="button" class="atlas-btn atlas-btn-secondary tall" [disabled]="isSaving"
          (click)="editBenefitModal.close()" icon="pi pi-times">
          {{ 'common.cancel' | translate | titlecase }}
        </button>
      </ng-template>
    </p-dialog>

    <p-dialog #flagBenefitModal [(visible)]="showFlagBenefitModal" modal="true" [closable]="false"
      styleClass="atlas-dialog-xl" [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
      <wl-benefit-flag [(benefitFlag)]="benefitFlag"></wl-benefit-flag>
      <ng-template pTemplate="footer">
        <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
        <button pButton type="button" class="atlas-btn atlas-btn-primary tall" [disabled]="isSaving"
          (click)="flagBenefit()" icon="pi pi-save">
          <span [hidden]="isSaving">{{ 'common.save' | translate | titlecase }}</span>
          <span [hidden]="!isSaving">{{ 'common.saving' | translate | titlecase }}</span>
        </button>
        <button pButton type="button" class="atlas-btn atlas-btn-secondary tall" [disabled]="isSaving"
          (click)="flagBenefitModal.close()" icon="pi pi-times">
          {{ 'common.cancel' | translate | titlecase }}
        </button>
      </ng-template>
    </p-dialog>
  </div>
</div>

<div [hidden]="hasEventBenefits" class="form-horizontal">
  {{ 'common.phrases.feature-no-access' | translate }}
</div>
